import React from 'react';
import { CategoriesSelector } from 'module/Redux/Categories';
import { Category } from 'module/Model/Categories';
import { connect } from 'react-redux';
import { createPureComponent, PathUtils } from 'module/Common';
import { Post } from 'module/Model/Post';
import { PostSelector } from 'module/Redux/Post';
import { RouterSelector } from 'module/Redux/Router';
import { State } from 'module/Redux';
import { Wish } from 'module/Model/Wish';
import { PublicationView } from 'module/View/Publication';

type StateProps = {
  postWish: Wish<Post>;
  categoriesWish: Wish<Array<Category>>;
  lang: PathUtils.Lang;
  routeIsInExitState: boolean;
};

const mapStateToProps = (s: State): StateProps => ({
  postWish: PostSelector.selectCurrent(s),
  categoriesWish: CategoriesSelector.selectForCurrentItem(s),
  lang: RouterSelector.selectLang(s),
  routeIsInExitState: RouterSelector.routeIsInExitState(s),
});

type OwnProps = {
  adminBar: boolean;
  availableWidth: number;
  previewData?: any;
};

type Props = StateProps & OwnProps;

const PostViewComp = createPureComponent<Props>(
  'PostView',
  ({ postWish, categoriesWish, lang, previewData, adminBar, availableWidth, routeIsInExitState }) => {
    return (
      <PublicationView
        adminBar={adminBar}
        availableWidth={availableWidth}
        categoriesWish={categoriesWish}
        isPage={false}
        lang={lang}
        previewData={previewData}
        publicationWish={postWish}
        routeIsInExitState={routeIsInExitState}
      />
    );
  }
);

export const PostView = connect(mapStateToProps)(PostViewComp);



// WEBPACK FOOTER //
// ./src/module/View/PostView/PostView.tsx